module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/zoom-plus-06da5f9d144484d15a30331ecb75f1cb.svg";